import React, { useContext, useEffect } from 'react';
import AppContext from 'contexts/appContext';
import Panel from 'components/common/panel/panel';

export default function UsersPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.Home, 'Users');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Users', selected: true }]);
  }, []);

  return (
    <div>Users</div>
  );
}